import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Footer.module.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faSquareFacebook, faTiktok } from "@fortawesome/free-brands-svg-icons";

import { LanguageContext } from '../../context/LanguageContext';

// Import des traductions 
import translations from '../../utils/translations/FooterTranslations';

const Footer = () => {
  const navigate = useNavigate();

  // Utilisation du contexte de langue global et accès simplifié aux traductions
  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.fr;

  return (
    <footer className={styles.footer}>
      <div className={styles.icons}>
        <a href="https://www.instagram.com/hatannaeditions" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} size="2x" className={styles.icon} /></a>
        <a href="https://www.facebook.com/hatannaRH" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faSquareFacebook} size="2x" className={styles.icon} /></a>
        <a href="https://www.tiktok.com/@hatannaeditions" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faTiktok} size="2x" className={styles.icon} /></a>
      </div>
      <div className={styles.container}>
        <ul>
          <li onClick={() => navigate("/legal")}>{t.legal}</li>
          <li onClick={() => navigate("/privacy")}>{t.privacy}</li>
          <li onClick={() => navigate("/conditions")}>{t.terms}</li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
